@if (!!cssClass) {
  <div [class]="'color-dot ' + cssClass" [class.display-border]="displayBorder()"></div>
}
@if (!!styleColor && styleColor !== 'transparent') {
  <div class="color-dot" [style.background-color]="styleColor" [class.display-border]="displayBorder()"></div>
} @else if (styleColor === 'transparent') {
  <div class="color-dot transparent" [class.display-border]="displayBorder()"></div>
}
